/* 공통 알림 배너. DOM/폼/React 소유권은 그대로 두고 표시만 fixed/top layer로 관리한다.
 * 조사 범위: docs/design-owner-inventories/2026-09-06-floating-notices-*.md */
(function (root, factory) {
    var api = factory();
    if (typeof module === 'object' && module.exports) {
        module.exports = api;
    }
    // Vite는 CommonJS export를 브라우저 번들 안에서도 감싼다. export 여부와 부팅을
    // 분리해야 실제 배포 번들에서도 초기화되며, Node/Jest에서만 자동 부팅을 생략한다.
    var isNode = typeof process === 'object' && process.versions && process.versions.node;
    if (root && root.document && !isNode) {
        root.skmFloatingNotices = api;
        if (root.document.readyState === 'loading') {
            root.document.addEventListener('DOMContentLoaded', function () { api.initFloatingNotices(root.document); }, { once: true });
        } else { api.initFloatingNotices(root.document); }
    }
})(typeof window !== 'undefined' ? window : null, function () {
    'use strict';

    // 일반 alert는 자동 적용. 고유 이름의 기존 배너도 같은 owner에 연결한다.
    // role=status/alert 전체는 잡지 않는다: 필드 오류·본문·상태 수치는 배너가 아니다.
    var NOTICE_SELECTOR = [
        '.alert', '.skm-alert', '.alert-banner', '.alert-error',
        '.alert-success', '.alert-danger', '.skm-flash-success', '.skm-flash-danger',
        '.skm-alert-success', '.skm-toast', '.cf-alert', '.cf-public__form-error',
        '.srv-guest__errors', '.skm-cross-branch-warning', '.skm-consulting-history__cross-branch',
        '.skm-sentry-notice', '.sc-hq-notice', '.management-history-notice', '.workers-notice',
        '.closing-readonly-notice', '.no-school-alert', '.book-create-alert', '.skm-class-bulk-alert',
        '.skm-mode-banner', '.alim-status-banner', '.public-catalog-admin__notice',
        '.public-catalog-admin__readonly', '.public-catalog-admin__errors', '.ep-focus-notice',
        '.ep-board-title__notice', '.rv__notice', '.csw-notice', '.csw-warning', '.csw-inline-status',
        '.srv-notice', '.sb-warn', '.sb-stale-note', '.skm-cal-offline', '.skm-wiki-banner',
        '.skm-wiki-dbt__note', '.skm-wiki-dbt__cap', '#save-status', '.timetable-mobile-banner', '.skm-timetable-notice',
        '#toast.toast', '#doneBanner.done', '.ke-toast', '.ke-rotate-hint', '.monitor-toast',
        '.fb-notice', '.skm-school-modal__notice', '.etm-banner', '.skm-billing-policy-notice',
        '.pi-notice', '.paid-notice', '.skm-payment-modal-notice', '.skm-pay-sandbox__notice',
        '.admin-test-banner', '.pa-dev-notice', '.resend-result', '.tk-chat-readonly-banner',
        '.salary-statistics-detail-warning', '.skm-pay-log__error', '[data-skm-notice]',
        '.ex-warn', '.sw-warn', '.alim-modal-error', '.alim-modal-success', '.atp-warn',
        '.skm-cal-form-error', '.pc-faq-editor-modal__error', '.ep-weakness__notice',
        '.swal2-toast', '#toast-container > .toast', '#our-webhook-result', '.v2-sv-link__warn',
    ].join(',');
    var CLOSE_SELECTOR = '[data-skm-notice-close], [data-skm-notice-close-mark], [data-bs-dismiss="alert"], .skm-toast-close, #flash_close, #flash_error_close, [data-skm-flash-close], .swal2-close, .toast-close-button';
    var instances = new WeakMap();

    function initFloatingNotices(doc) {
        doc = doc || document;
        if (instances.has(doc)) { return instances.get(doc); }
        var win = doc.defaultView;
        var records = new Map();
        var scheduled = null;
        var stopped = false;

        function setAttr(el, name, value) {
            if (value === null) { if (el.hasAttribute(name)) { el.removeAttribute(name); } }
            else if (el.getAttribute(name) !== value) { el.setAttribute(name, value); }
        }
        function content(el) {
            var text = '';
            Array.prototype.forEach.call(el.childNodes, function read(node) {
                if (node.nodeType === 3) { text += node.textContent; return; }
                if (node.nodeType !== 1 || node.matches(CLOSE_SELECTOR + ',script,style')) { return; }
                Array.prototype.forEach.call(node.childNodes, read);
            });
            return text.trim();
        }
        function sourceStyle(el) {
            return [el.style.display, el.style.visibility, el.style.opacity].join('|');
        }
        function ancestorsVisible(el) {
            for (var parent = el.parentElement; parent; parent = parent.parentElement) {
                if (parent.hidden || parent.getAttribute('aria-hidden') === 'true') { return false; }
                if (parent.tagName === 'DETAILS' && !parent.open && !el.closest('summary')) { return false; }
                var style = win.getComputedStyle(parent);
                if (style.display === 'none' || style.visibility === 'hidden') { return false; }
            }
            return true;
        }
        function closePopover(el) {
            if (typeof el.hidePopover === 'function' && el.matches(':popover-open')) { el.hidePopover(); }
        }
        function showPopover(el) {
            if (typeof el.showPopover !== 'function') { return; }
            setAttr(el, 'popover', 'manual');
            if (!el.matches(':popover-open')) { el.showPopover(); }
        }
        // ── 설명글은 떠다니지 않는다 (원장님 지시 2026-09-13) ──────────────────
        // 안내·참고사항(tone=info)은 화면을 가리는 floating 대신 **페이지 맨 아래 도움말**로 내린다.
        // 경고·오류(warning/danger/success)는 즉시 조치가 필요하므로 그대로 화면 중앙에 띄운다.
        //
        // 노드를 **옮긴다**. 복제하면 같은 문구가 두 번 보이고(§4.2 복제 금지) 원본이 갱신돼도
        // 사본이 안 따라온다. 대신 원래 자리(부모·다음 형제)를 기록해 release() 가 되돌린다 —
        // 화면이 그 노드를 inline 으로 되돌릴 때 DOM 이 원상복구돼야 기존 동작이 안 깨진다.
        function helpBody() {
            var host = doc.getElementById('skm-page-help');
            if (!host) { return null; }
            return host.querySelector('[data-skm-page-help-body]') || host;
        }
        // 스스로 사라지는 알림(토스트)은 도움말로 내리지 않는다. 페이지 맨 아래는 «상시 읽는 자리» 인데
        // 토스트는 몇 초 뒤 없어지므로 거기 두면 아무도 못 본다. 게다가 swal2/toastr 는 자기 컨테이너
        // 안의 노드를 직접 지우므로 뜯어 오면 닫기·타이머가 끊긴다. 토스트는 종전대로 떠 있는다.
        var TRANSIENT_SELECTOR = '.swal2-toast, .swal2-popup, .skm-toast, .ke-toast, .ke-rotate-hint, .monitor-toast, .toast';
        var TRANSIENT_HOST_SELECTOR = '.swal2-container, #toast-container, .toast-container';
        function isTransient(el) {
            return el.matches(TRANSIENT_SELECTOR) || Boolean(el.closest(TRANSIENT_HOST_SELECTOR));
        }
        function moveToHelp(el, record) {
            if (isTransient(el)) { return false; }
            var body = helpBody();
            if (!body || el.parentNode === body) { return Boolean(body); }
            if (!record.homeParent) {
                record.homeParent = el.parentNode;
                record.homeNext = el.nextSibling;
            }
            closePopover(el);
            body.appendChild(el);
            return true;
        }
        function restoreHome(el, record) {
            if (!record.homeParent) { return; }
            // 원래 부모가 이미 사라졌으면 되돌릴 자리가 없다 — 그대로 둔다(끊긴 노드를 만들지 않는다).
            if (record.homeParent.isConnected) {
                record.homeParent.insertBefore(el, record.homeNext && record.homeNext.isConnected ? record.homeNext : null);
            }
            record.homeParent = null;
            record.homeNext = null;
        }
        function syncHelpHost() {
            var host = doc.getElementById('skm-page-help');
            if (!host) { return; }
            var body = helpBody();
            var has = Boolean(body && body.querySelector('[data-skm-notice-placement="help"]:not([data-skm-notice-suppressed])'));
            setAttr(host, 'hidden', has ? null : '');
        }

        function ensureClose(el, record) {
            if (el.querySelector(CLOSE_SELECTOR)) { return; }
            var button = doc.createElement('button');
            button.type = 'button';
            button.className = 'skm-floating-notice__close';
            button.setAttribute('data-skm-notice-close', '');
            button.setAttribute('aria-label', '알림 닫기');
            button.textContent = '×';
            record.generatedClose = button;
            el.appendChild(button);
        }
        function tone(el) {
            var name = el.className + ' ' + (el.getAttribute('role') || '') + ' ' + (el.getAttribute('data-kind') || el.getAttribute('data-tone') || '');
            if (/danger|error|--err\b|--bad\b|\bis-bad\b/.test(name)) { return 'danger'; }
            if (/success|--ok\b/.test(name)) { return 'success'; }
            if (/warn|offline|readonly|--notice\b/.test(name)) { return 'warning'; }
            return 'info';
        }
        function dismiss(el) {
            if (!records.has(el)) { return; }
            setAttr(el, 'data-skm-notice-dismissed', 'true');
            closePopover(el);
            refresh();
        }
        // 오류와 정상 진행 상태를 같은 노드에 쓰는 화면은 inline으로 돌아올 수 있다.
        // 안내 표시만 해제하며 원본 DOM·이벤트·업무 상태는 손대지 않는다.
        function release(el, record) {
            closePopover(el);
            restoreHome(el, record);
            if (record.generatedClose && record.generatedClose.parentNode === el) { record.generatedClose.remove(); }
            ['data-skm-floating-notice', 'data-skm-notice-dismissed', 'data-skm-notice-empty', 'data-skm-notice-tone', 'data-skm-notice-suppressed', 'data-skm-notice-placement'].forEach(function (name) { el.removeAttribute(name); });
            el.style.removeProperty('--skm-notice-top');
            el.style.removeProperty('--skm-notice-max-height');
            setAttr(el, 'popover', record.originalPopover);
            records.delete(el);
        }
        function refresh() {
            if (stopped) { return; }
            records.forEach(function (record, el) {
                if (el.getAttribute('data-skm-notice') === 'inline') { release(el, record); }
            });
            var candidates = doc.querySelectorAll(NOTICE_SELECTOR);
            candidates.forEach(function (el) {
                if (el.getAttribute('data-skm-notice') === 'inline') { return; }
                if (el.closest('template,noscript,[data-skm-notice-content]')) { return; }
                // 중첩된 설명은 바깥 알림의 일부다. 별도 박스로 중복 렌더하지 않는다.
                if (el.parentElement && el.parentElement.closest(NOTICE_SELECTOR)) { return; }
                if (!records.has(el)) {
                    records.set(el, { text: content(el), sourceClass: el.className, sourceStyle: sourceStyle(el),
                        ancestorVisible: ancestorsVisible(el), originalPopover: el.getAttribute('popover') });
                    setAttr(el, 'data-skm-floating-notice', '');
                }
            });
            var visible = [];
            records.forEach(function (record, el) {
                if (!el.isConnected) { records.delete(el); return; }
                var text = content(el);
                var ancestorVisible = ancestorsVisible(el);
                if (record.text !== text || (!record.ancestorVisible && ancestorVisible)) {
                    setAttr(el, 'data-skm-notice-dismissed', null);
                }
                record.text = text;
                record.sourceClass = el.className;
                record.sourceStyle = sourceStyle(el);
                record.ancestorVisible = ancestorVisible;
                setAttr(el, 'data-skm-notice-empty', text ? null : 'true');
                setAttr(el, 'data-skm-notice-tone', tone(el));
                if (!text || !ancestorVisible || el.hidden || el.getAttribute('aria-hidden') === 'true' || el.getAttribute('data-skm-notice-dismissed') === 'true') {
                    setAttr(el, 'data-skm-notice-suppressed', 'true');
                    closePopover(el);
                    return;
                }
                setAttr(el, 'data-skm-notice-suppressed', null);
                // 설명글(info)은 맨 아래 도움말로 내린다 — 떠다니지 않고 X 도 붙이지 않는다(상시 노출).
                // 도움말 영역이 없는 레이아웃에서는 종전 동작(floating)으로 남는다 — 안내가 사라지면 안 된다.
                if (el.getAttribute('data-skm-notice-tone') === 'info' && moveToHelp(el, record)) {
                    setAttr(el, 'data-skm-notice-placement', 'help');
                    return;
                }
                setAttr(el, 'data-skm-notice-placement', null);
                restoreHome(el, record);
                ensureClose(el, record);
                // manual popover는 DOM 조상을 유지한 채 최상위 표시 레이어만 사용한다.
                // 미지원 브라우저에서도 아래 공통 fixed CSS와 X는 그대로 동작한다.
                showPopover(el);
                var style = win.getComputedStyle(el);
                if (el.hidden || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') { return; }
                visible.push(el);
            });
            var top = 12;
            var viewport = win.innerHeight || 800;
            var gap = 8;
            // 여러 장도 화면 안에 남게 높이를 나눠 각 본문을 스크롤한다.
            var allowance = Math.max(48, Math.min(viewport * 0.6, (viewport - 24 - gap * Math.max(0, visible.length - 1)) / Math.max(1, visible.length)));
            visible.forEach(function (el) {
                var heightValue = Math.floor(allowance) + 'px';
                if (el.style.getPropertyValue('--skm-notice-max-height') !== heightValue) { el.style.setProperty('--skm-notice-max-height', heightValue); }
                var topValue = Math.round(top) + 'px';
                if (el.style.getPropertyValue('--skm-notice-top') !== topValue) { el.style.setProperty('--skm-notice-top', topValue); }
                top += Math.min(el.getBoundingClientRect().height || 48, allowance) + gap;
            });
            // 도움말 영역은 담긴 설명글이 있을 때만 보인다 — 빈 제목만 남으면 페이지 아래가 지저분하다.
            syncHelpHost();
        }
        function schedule() {
            if (scheduled !== null || stopped) { return; }
            scheduled = win.setTimeout(function () { scheduled = null; refresh(); }, 0);
        }
        function onClick(event) {
            var button = event.target.closest && event.target.closest(CLOSE_SELECTOR);
            if (!button) { return; }
            var el = button.closest('[data-skm-floating-notice]');
            // React가 직접 상태를 닫는 기존 버튼은 그 onClick을 그대로 실행한다.
            if (!el || button.hasAttribute('data-skm-notice-close-mark') || button.matches('.swal2-close,.toast-close-button')) { return; }
            event.preventDefault();
            event.stopImmediatePropagation();
            dismiss(el);
        }
        var observer = new win.MutationObserver(function (mutations) {
            var relevant = false;
            mutations.forEach(function (mutation) {
                var node = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
                if (!node) { return; }
                if (mutation.type === 'attributes' && mutation.attributeName.indexOf('data-skm-') === 0 && mutation.attributeName !== 'data-skm-notice') { return; }
                if (mutation.type === 'attributes' && mutation.attributeName === 'popover') { return; }
                if (node.closest(CLOSE_SELECTOR)) { return; }
                var el = node.closest('[data-skm-floating-notice]');
                var record = el && records.get(el);
                if (mutation.type === 'attributes' && mutation.attributeName === 'style' && record && node === el && record.sourceStyle === sourceStyle(el)) { return; }
                if (mutation.type === 'childList') {
                    var changed = Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes));
                    if (changed.length && changed.every(function (child) { return child.nodeType === 1 && child.matches(CLOSE_SELECTOR); })) { return; }
                }
                relevant = true;
                if (record && (mutation.type !== 'attributes' || (node === el && (mutation.attributeName === 'hidden' || mutation.attributeName === 'class' || mutation.attributeName === 'style')))) {
                    setAttr(el, 'data-skm-notice-dismissed', null);
                }
            });
            if (relevant) { schedule(); }
        });
        // Bootstrap의 document capture 위임보다 먼저 처리해야 원본 alert가 삭제되지 않는다.
        win.addEventListener('click', onClick, true);
        win.addEventListener('resize', schedule);
        doc.addEventListener('toggle', schedule, true);
        doc.addEventListener('transitionend', schedule, true);
        observer.observe(doc.documentElement, { subtree: true, childList: true, characterData: true, attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open', 'data-skm-notice'] });
        var api = { refresh: refresh, destroy: function () {
            stopped = true;
            observer.disconnect();
            if (scheduled !== null) { win.clearTimeout(scheduled); }
            win.removeEventListener('click', onClick, true);
            doc.removeEventListener('toggle', schedule, true);
            doc.removeEventListener('transitionend', schedule, true);
            win.removeEventListener('resize', schedule);
            records.forEach(function (record, el) { release(el, record); });
            records.clear();
            instances.delete(doc);
        } };
        instances.set(doc, api);
        refresh();
        return api;
    }
    return { initFloatingNotices: initFloatingNotices, NOTICE_SELECTOR: NOTICE_SELECTOR };
});
